import { useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { getDate } from "../../../utils/getStrDate";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { getTime } from "../../../utils/getStrTime";
import { DeleteIcon } from "../../../assets/icons";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import TableAPI from "../../../api/TableAPI";

import styles from "./weekDayPopup.module.css";
import { useParams } from "react-router";

import { Text } from "../../../components/text/text";

const weekDays = ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"];

export const WeekDayPopup = ({ date, shift, setShift }) => {
    const weekDay = date.getDay();

    const [employees, setEmployees] = useState([]);

    const { cafeId } = useParams();
    useEffect(() => {
        setEmployees([]);
        if (cafeId === null || !shift) return;
        TableAPI
            .fetchAdminShiftInfo(cafeId, shift.shiftDate)
            .then(res => setEmployees(res))
            .catch(console.error)
    }, [cafeId, shift]);

    const navigate = useAnimatedNavigate();

    const getShiftTime = (start, end) => {
        const startTimeComponents = start.split(":")
        const startTime = new Date(
            1970, 0, 1,
            startTimeComponents[0],
            startTimeComponents[1],
            startTimeComponents[2]
        )

        const endTimeComponents = end.split(":")
        const endTime = new Date(
            1970, 0, 1,
            endTimeComponents[0],
            endTimeComponents[1],
            endTimeComponents[2]
        )

        return `${getTime(startTime)} - ${getTime(endTime)}`;
    }


    const onDeleteShift = (userId) => {
        TableAPI
            .cancelShift(cafeId, userId, date)
            .then(() => {
                setShift({ ...shift, countEmployees: employees.length - 1 });
                setEmployees(prev => prev.filter(el => el.employee.userId !== userId));
            })
            .catch(console.error);
    }

    return (
        <>
            <div className={styles.shift_date_container}>
                <Text as="div" variant="h1" className={styles.shift_date_title} >
                    {weekDays[weekDay]} {getDate(date)}
                </Text>
                <Text as="div" variant="h3" className={styles.shift_date_subtitle} size={14} lineHeight="1">Сотрудники смены</Text>
            </div>

            {
                employees.length === 0 &&
                <Text as="div" variant="body" className={styles.no_employees} >
                    На эту смену сотрудники еще не назначены.
                </Text>
            }

            {
                employees.length !== 0 &&
                <div className={styles.employees_on_shift}>
                    {
                        employees.map(data => (
                            <Button
                                noActiveAnimation
                                key={data.employee.userId}
                                text={<ProfileInfo name={data.employee.name} userId={data.employee.userId} />}
                                type="hint"
                                icon={
                                    <div className={styles.shift_info}>
                                        {getShiftTime(data.startTime, data.endTime)}
                                        <DeleteIcon className={styles.delete_icon} onClick={() => onDeleteShift(data.employee.userId)} />
                                    </div>
                                }
                            />
                        ))
                    }
                </div>
            }

            <Button
                text="Добавить сотрудника"
                onClick={() => navigate(`/admin/${cafeId}/cafe/table/add?date=${date.toISOString().split("T")[0]}`)}
                type="primary"
            />
        </>
    );
}